/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompagecount2Inputs */

const en_entity_custompagecount2 = /** @type {(inputs: Entity_Custompagecount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Page Count`)
};

const de_entity_custompagecount2 = /** @type {(inputs: Entity_Custompagecount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Zusatzseiten`)
};

/**
* | output |
* | --- |
* | "Custom Page Count" |
*
* @param {Entity_Custompagecount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompagecount2 = /** @type {((inputs?: Entity_Custompagecount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompagecount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompagecount2(inputs)
	return de_entity_custompagecount2(inputs)
});
export { entity_custompagecount2 as "entity_customPageCount" }